import { Event } from '@livecontrol/scheduler/model';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import type { UseEventsHook } from './use-events';
import { useEvents } from './use-events';

import Phase = Event.Phase;

export const useUpcomingEvents: UseEventsHook = (filters) => {
  const pastEventCutoff = useMemo(() => new Date(Date.now() - 30 * 60 * 1000).toISOString(), []);


  /* No onUpdate handler: see the comment in `use-live-events.ts` — it made events blink out. */
  const results = useEvents(filters, {
    status: Phase.Upcoming,
    end_time_gte: pastEventCutoff
  });

  const events = useMemo(
    () => results.events?.filter((v) => DateTime.fromISO(v.startTime) > DateTime.now().minus({ minutes: 30 })),
    [results.events]
  );

  return { ...results, events };
};
